var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6749 37.4999C23.6749 36.4644 22.8354 35.6249 21.7999 35.6249C20.7644 35.6249 19.9249 36.4644 19.9249 37.4999C19.9249 38.5357 20.7644 39.3749 21.7999 39.3749C22.8354 39.3749 23.6749 38.5357 23.6749 37.4999Z",
    fill: "#6C84F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2309 13.855H33.869C42.306 13.855 46.5245 13.855 48.8943 16.3221C51.2638 18.7892 50.7063 22.6009 49.5913 30.2239L48.5338 37.4529C47.6593 43.431 47.2223 46.42 44.9793 48.21C42.7363 50 39.428 50 32.8115 50H18.2882C11.6719 50 8.36367 50 6.12069 48.21C3.8777 46.42 3.44047 43.431 2.56602 37.4529L1.50859 30.2239C0.393505 22.6009 -0.164023 18.7892 2.20561 16.3221C4.57525 13.855 8.7938 13.855 17.2309 13.855ZM27.4249 21.2499C27.4249 20.2143 26.5854 19.375 25.5499 19.375C24.5144 19.375 23.6749 20.2143 23.6749 21.2499V32.1952C23.0884 31.9879 22.4574 31.8749 21.7999 31.8749C18.6933 31.8749 16.1749 34.3934 16.1749 37.4999C16.1749 40.6067 18.6933 43.125 21.7999 43.125C24.9064 43.125 27.4249 40.6067 27.4249 37.4999V28.2994C29.1005 29.6584 31.2042 30.6249 33.05 30.6249C34.0855 30.6249 34.925 29.7856 34.925 28.7499C34.925 27.7144 34.0855 26.8749 33.05 26.8749C32.2865 26.8749 30.8362 26.3284 29.5087 25.1506C28.2135 24.0016 27.4249 22.5966 27.4249 21.2499Z",
    fill: "#6C84F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8238 1.82323e-05H34.2742C34.8552 -0.000131769 35.301 -0.000231623 35.6905 0.0378686C38.46 0.308795 40.727 1.97395 41.6883 4.21696H9.40973C10.371 1.97395 12.6379 0.308795 15.4075 0.0378686C15.797 -0.000231623 16.2426 -0.000131769 16.8238 1.82323e-05Z",
    fill: "#6C84F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3254 6.80668C7.84879 6.80668 4.9981 8.90606 4.04677 11.6912C4.02695 11.7492 4.00795 11.8076 3.98977 11.8662C4.98515 11.5648 6.02106 11.3679 7.06974 11.2335C9.77068 10.8872 13.184 10.8874 17.1491 10.8876H34.3795C38.3445 10.8874 41.758 10.8872 44.4588 11.2335C45.5075 11.3679 46.5435 11.5648 47.5388 11.8662C47.5208 11.8076 47.5015 11.7492 47.4818 11.6912C46.5305 8.90606 43.6798 6.80668 40.2033 6.80668H11.3254Z",
    fill: "#6C84F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.c0c94f9a13176464887732bfb27d791c.svg";
export { ForwardRef as ReactComponent };